import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderHistoryDetails', {
  details: 'Detalle pedido',
  history: 'Historial de estados'
});

i18next.addResources('es_CR', 'OrderHistoryDetails', {
  details: 'Detalle pedido',
  history: 'Historial de estados'
});
